<template>
  <img
    v-if="iconColor === 'white'"
    src="../assets/img/arrow-left-white.svg"
    class="backToPosts"
    alt="Powrót"
    title="Powrót"
    @click="goBack"
  />
  <img
    v-else
    src="../assets/img/arrow-left-dark.svg"
    class="backToPosts"
    alt="Powrót"
    title="Powrót"
    @click="goBack"
  />
</template>

<script>
import { bus } from "../main";

export default {
  name: "BackToPostListArrow",
  methods: {
    goBack: function() {
      if (this.screen === "pp") {
        bus.$emit("hidePP");
      } else {
        bus.$emit("hidePost", "post-list");
      }
    }
  },
  props: {
    screen: String,
    iconColor: String
  }
};
</script>

<style lang="scss">
.backToPosts {
  cursor: pointer;

  &:hover {
    transform: rotate(30deg);
  }
}
</style>